export const ADMIN = 'Site Admin';
export const STORE_OWNER = 'Store Owner';
export const PHARMACY_MANAGER = 'Pharmacy Manager';
export const PHARMACIST = 'Pharmacist';

export const UserRole = Object.freeze({
    ADMIN: 'Site Admin',
    STORE_OWNER: 'Store Owner',
    PHARMACY_MANAGER: 'Pharmacy Manager',
    PHARMACIST: 'Pharmacist'
});

export const UserRoleValue = Object.freeze({
    STORE_OWNER: 'ROLE_OWNER',
    PHARMACY_MANAGER: 'ROLE_MANAGER',
    PHARMACIST: 'ROLE_PHARMACIST'
});





// WEBPACK FOOTER //
// ./src/customModules/Common/UserRole.js